import React, { FC } from 'react';
import { Element } from 'features/document/constants';
import ComponentFactory from 'pages/DocumentBuilder/components/ContentSection/components/ElementSection/components/ComponentFactory/ComponentFactory';
import styles from './ViewerElementSection.module.css';

interface ViewerElementSectionProps {
  currentElement: Element;
}

const ViewerElementSection: FC<ViewerElementSectionProps> = ({ currentElement }) => {
  return (
    <div className={styles.mainContainer}>
      <ComponentFactory currentElement={currentElement} isViewMode={true} />
    </div>
  );
};

export default ViewerElementSection;
